import { render } from "./ArtistsPage.vue?vue&type=template&id=5e002e74"
import script from "./ArtistsPage.vue?vue&type=script&lang=js"
export * from "./ArtistsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__